import React from 'react';
import { ProFormTextArea, ProFormDatePicker } from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import ProForm from 'components/layout/ProForm';
import { FormUpload } from 'components/input';
import { SelectFaculty, SelectProjectCategory } from 'components/input';

const AnnualReportForm = ({
  onFinish,
  initialValues,
  reportingPeriod,
  canCustomDate,
  loading,
}) => {
  return (
    <ProForm
      loading={loading}
      onFinish={onFinish}
      initialValues={initialValues}
    >
      <ProFormDatePicker
        width="xl"
        name="actualSubmissionDate"
        label="Actual Submission Date"
        placeholder="YYYY-MM-DD"
        disabled={canCustomDate ? false : true}
        rules={[{ required: true }]}
      />
      <SelectFaculty disabled={canCustomDate ? false : true} />
      <SelectProjectCategory />
      <FormUpload
        maxCount={1}
        name="attachment"
        label="Attachment"
        rules={[{ required: true, message: 'Please upload file!' }]}
        projectId="AnnualReport"
        subFolder={reportingPeriod}
      />
      <ProFormTextArea
        width="xl"
        name="Remarks"
        label="remarks"
        placeholder="please enter (optional)"
      />
    </ProForm>
  );
};

AnnualReportForm.defaultProps = {
  initialValues: {},
  canCustomDate: false,
  loading: true,
};

AnnualReportForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  reportingPeriod: PropTypes.string.isRequired,
  canCustomDate: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default AnnualReportForm;
